import { render } from "./MainInsured.vue?vue&type=template&id=78d0f293"
import script from "./MainInsured.vue?vue&type=script&lang=ts"
export * from "./MainInsured.vue?vue&type=script&lang=ts"
script.render = render

export default script